/*
 * 3-Б7 «Публичный профиль мастера» — числа из макета «Данные клиента и группы - П2»:
 * карточка 640 в две колонки (1fr 250px, зазор 16), поля с зазором 10; фото 72 круглое
 * со штриховкой-заглушкой; карточка витрины — радиус 18, фото 84, имя 16, кнопка 44 × 100 %
 * с радиусом 12. На телефоне предпросмотр уходит на отдельный экран («Как видит клиент»).
 */

.screen {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.card {
  display: grid;
  grid-template-columns: 1fr 250px;
  gap: 16px;
  width: min(640px, 100% - 2 * var(--space-4));
  margin: var(--space-3) var(--space-4);
  padding: 16px;
  font-size: 12.5px;
  line-height: 1.5;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 12px;
}

.formColumn {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.title {
  font-size: 15px;
  font-weight: var(--font-weight-semibold);
}

.subtitle,
.hint {
  font-size: 12px;
  color: var(--text-secondary);
}

.status {
  font-size: 12px;
  color: var(--text-secondary);
}

.photoRow {
  display: flex;
  gap: 12px;
  align-items: center;
}

.photo,
.previewPhoto {
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  object-fit: cover;
  background: repeating-linear-gradient(45deg, var(--bg-sunken) 0 6px, var(--bg-card) 6px 12px);
  border: 1px solid var(--border-strong);
  border-radius: 50%;
}

.photo {
  width: 72px;
  height: 72px;
  font-family: ui-monospace, Menlo, monospace;
  font-size: 10px;
  color: var(--text-secondary);
}

.photoActions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}

.switchRow {
  justify-content: space-between;
}

.notShared {
  padding: 9px 12px;
  font-size: 12px;
  color: var(--text-secondary);
  background: var(--bg-workspace);
  border-radius: 8px;
}

.notShared b {
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
}

.outcome {
  padding: 9px 12px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.problem {
  padding: 9px 12px;
  color: var(--danger);
  border: 1.5px solid var(--danger-hover);
  border-radius: 8px;
}

.buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.previewColumn {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.previewCard {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  padding: 14px;
  text-align: center;
  background: var(--bg-card);
  border: 1px solid var(--border-strong);
  border-radius: 18px;
}

.previewPhoto {
  width: 84px;
  height: 84px;
}

.previewName {
  font-size: 16px;
  font-weight: var(--font-weight-semibold);
  overflow-wrap: anywhere;
}

.previewPosition {
  font-size: 11.5px;
  color: var(--text-secondary);
}

.previewAbout {
  font-size: 12px;
  line-height: 1.45;
  color: var(--text-brand);
  overflow-wrap: anywhere;
}

.previewServices {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  justify-content: center;
}

.previewButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 44px;
  font-weight: var(--font-weight-semibold);
  color: var(--text-on-accent);
  background: var(--accent);
  border-radius: 12px;
}

/* Кнопка «Как видит клиент» нужна только на узком экране: на широком предпросмотр рядом. */
.previewToggle {
  display: none;
}

@media (max-width: 767px) {
  .card {
    grid-template-columns: 1fr;
    width: auto;
  }

  .previewDesktop {
    display: none;
  }

  .previewToggle {
    display: inline-flex;
  }
}
